import { isSistaminuten } from '@/helpers/general';
import { BokadirektPayBadges, getBokadirektPayBadges, showsBokadirektPayBadges } from '@/helpers/placeHelperTS';
import { placeService } from '@/services/placeServices';
import { PlaceEmployee } from '@/types/state/shared';
import { useEffect, useState } from 'react';

type BadgePlace = { id?: number; lastMinuteDiscount?: number };

/**
 * The Klarna and Walley badges a Bokadirekt Pay employee gets at this place, fetched once the employee
 * is shown. None while loading, after a failed lookup, and when the badges would be hidden anyway,
 * which makes no request.
 */
const useBokadirektPayBadges = (
  place: BadgePlace | undefined,
  employee: PlaceEmployee | undefined,
): BokadirektPayBadges => {
  const [methods, setMethods] = useState<BokadirektPayBadges>();
  const placeId = place?.id;
  const employeeId = employee?.id;
  const isSistaminutenView = isSistaminuten() || Boolean(place?.lastMinuteDiscount);
  const shown = showsBokadirektPayBadges(employee, isSistaminutenView);

  useEffect(() => {
    setMethods(undefined);
    if (!placeId || !employeeId || !shown) return;

    let current = true;
    placeService
      .getPaymentMethodBadges(placeId, [employeeId])
      .then((result) => current && setMethods(result?.[employeeId]))
      // Badges are decoration: a failed lookup only leaves them out.
      .catch(() => {});
    return () => {
      current = false;
    };
  }, [placeId, employeeId, shown]);

  return getBokadirektPayBadges(employee, methods, isSistaminutenView);
};

export default useBokadirektPayBadges;
